//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdeProcesRealizaceDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      JKLUSACEK                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-12-01                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.38.1
//AdtGeneratorConfig:[ T:(srvsprr) GID:(Web.Set.Des.Ts) V1:(ixs_prr,nazev,zkratka,poznamka,rok_od,rok_do,ixs_sro_az,aktivita,dat_zmena,zmenu_prov) V2:() K1:() K2:() K3:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamAdeProcesRealizaceDesigner
     * 
     * @author JKLUSACEK
     * @since 482.1.0.119
     */
    export class SeznamAdeProcesRealizaceDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - ixs_prr */
            public ixs_prr: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdeProcesRealizaceListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdeProcesRealizaceDesigner>, ixs_prr: string  ): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, ixs_prr);
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction );

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdeProcesRealizaceDesigner>, ixs_prr: string ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamAdeProcesRealizaceDesigner>, ev, ctx): any {
            var filterObj = {
            }
            that.view = new Gordic.Isl.View(that.isl.AdeProcesRealizace.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamAdeProcesRealizaceDesignerInit
         * 
         * @param {GContentType<SeznamAdeProcesRealizaceDesigner>} that
         */
        static SeznamAdeProcesRealizaceDesignerInit(that: GContentType<SeznamAdeProcesRealizaceDesigner>, ixs_prr: string, withFilterPanel: boolean) {

            this.SeznamBaseInit(that);
            if (withFilterPanel == true)
               that.filter = this.createFilter(that, ixs_prr);

            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);

            var filterObj: any = {}
            that.view = new Gordic.Isl.View(that.isl.AdeProcesRealizace.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem

        } // SeznamAdeProcesRealizaceDesignerInit

        static LoadData(that: GContentType<SeznamAdeProcesRealizaceDesigner>, ixs_prr: string) {
            var filterObj: any = {};
            that.view = new Gordic.Isl.View(that.isl.AdeProcesRealizace.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false })
        }

    }
}
